import * as React from 'react';
import {AvatarElement, NavContainer} from './Navigator.style';
import {NavigatorProps} from './Navigator.type';
import {useNavigator} from './Navigator.use-case';
import {NavigatorService} from './Navigator.service';
import {NavigatorMap} from './Navigator.map';
import {ProfileNavItem} from './_components/profile-nav-item';
import {FilialNavItem} from './_components/filial-nav-item';
import {UserNavItem} from './_components/user-nav-item';
import {NavItem} from './_components/nav-item';

export default function Navigator({account, user}: NavigatorProps) {
  const _useNavigator = useNavigator(account);

  if (!NavigatorService.validateNavigatorProps(account, user)) {
    return null;
  }

  const featuresSchema = NavigatorMap.getFeatureSchema();
  return (
    <NavContainer
      onClick={_useNavigator.toggleAtivoClass}
      className={_useNavigator.hasTheme ? 'nav-themed' : ''}>
      <AvatarElement src={account?.avatar?.uri} alt={`${account.name} logo`} />
      <ul>
        <ProfileNavItem
          user={user}
          account={account}
          activeItem={_useNavigator.activeItem}
          onOpenSubmenu={_useNavigator.openSubmenu}
        />

        {_useNavigator.featuresFiltered.map(
          (feature: string, index: number) => {
            if (feature === 'filials') {
              return (
                <FilialNavItem
                  key={feature}
                  account={account}
                  activeItem={_useNavigator.activeItem}
                  pathName={_useNavigator.pathName}
                  onOpenSubmenu={_useNavigator.openSubmenu}
                />
              );
            }

            if (feature === 'users') {
              return (
                <UserNavItem
                  key={feature}
                  account={account}
                  activeItem={_useNavigator.activeItem}
                  pathName={_useNavigator.pathName}
                  onOpenSubmenu={_useNavigator.openSubmenu}
                />
              );
            }

            if (!NavigatorService.isValidFeature(feature)) {
              return null;
            }

            return (
              <NavItem
                key={feature}
                feature={feature}
                account={account}
                activeItem={_useNavigator.activeItem}
                pathName={_useNavigator.pathName}
                onOpenSubmenu={_useNavigator.openSubmenu}
                schema={featuresSchema[feature]}
              />
            );
          },
        )}
      </ul>
    </NavContainer>
  );
}
